import LocaleSwitcherSale from "./components/LocaleSwitcherSale";

if (!window.customElements.get("arcteryx-locale-switcher")) {
  window.customElements.define("arcteryx-locale-switcher", LocaleSwitcherSale);
}
